import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import { HutsList, HutDetail } from "@/pages/Huts";
import Booking from "@/pages/Booking";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { Info, Regulations, Location, Contact, Legal, Privacy } from "@/pages/StaticPages";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { AuthProvider } from "@/lib/AuthContext";

function PublicShell({ children }) {
  const [online, setOnline] = useState(true);
  useEffect(() => {
    api.get("/site-status").then(r => setOnline(r.data.online)).catch(() => setOnline(true));
  }, []);
  if (!online) return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FAF8F5] px-4 text-center" data-testid="maintenance-page">
      <div className="font-serif text-3xl text-emerald-900 mb-3">Site momentanément indisponible</div>
      <p className="text-stone-600 max-w-md">Le site de l'AGCVS est actuellement hors ligne pour maintenance.<br/>Merci de revenir un peu plus tard.</p>
      <a href="/admin/login" className="mt-8 text-xs text-stone-400 hover:text-emerald-800">Espace administrateur</a>
    </div>
  );
  return (<><Header/><main className="min-h-[60vh]">{children}</main><Footer/></>);
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<PublicShell><Home/></PublicShell>}/>
          <Route path="/huttes" element={<PublicShell><HutsList/></PublicShell>}/>
          <Route path="/huttes/:slug" element={<PublicShell><HutDetail/></PublicShell>}/>
          <Route path="/reserver" element={<PublicShell><Booking/></PublicShell>}/>
          <Route path="/paiement/succes" element={<PublicShell><PaymentSuccess/></PublicShell>}/>
          <Route path="/paiement/annule" element={<PublicShell><PaymentCancel/></PublicShell>}/>
          <Route path="/informations" element={<PublicShell><Info/></PublicShell>}/>
          <Route path="/reglement" element={<PublicShell><Regulations/></PublicShell>}/>
          <Route path="/localisation" element={<PublicShell><Location/></PublicShell>}/>
          <Route path="/contact" element={<PublicShell><Contact/></PublicShell>}/>
          <Route path="/mentions-legales" element={<PublicShell><Legal/></PublicShell>}/>
          <Route path="/confidentialite" element={<PublicShell><Privacy/></PublicShell>}/>
          <Route path="/admin/login" element={<AdminLogin/>}/>
          <Route path="/admin" element={<AdminDashboard/>}/>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
